export const locale = {
    lang: 'en',
    data: {
        NAV: {
            APPLICATIONS: 'Menu Principal',
            MODULES: 'Módulos',
            PAINEL        : {
                TITLE: 'Painel',
            },
            ADMIN        : {
                TITLE: 'Administrador',
            },
            SUPERADMIN        : {
                TITLE: 'SuperAdmin',
            },
            COORDENADOR  : {
                TITLE: 'Coordenador',
            },
            ARQUIVISTA        : {
                TITLE: 'Arquivista',
            },
            TAREFA        : {
                TITLE: 'Tarefas',
                ADMINISTRATIVAS: {
                    TITLE: 'Administrativas'
                }
            },
            PROTOCOLO        : {
                TITLE: 'Protocolo',
                ADMINISTRATIVO: {
                    TITLE: 'Administrativo'
                },
            },
            PESQUISA        : {
                TITLE: 'Pesquisa'
            },
            RELATORIO        : {
                TITLE: 'Relatórios'
            },
            OFICIO : {
                TITLE: 'Ofícios'
            },
            PROTOCOLO_EXTERNO : {
                TITLE: 'Protocolo'
            },
            CAIXA_EMAIL: {
                TITLE: 'Caixa de E-mail'
            },
            PESSOAS: {
                TITLE: 'Sapiens Pessoas'
            },
            TODAS_TAREFA: {
                TITLE: 'Todas as tarefas'
            }
        }
    }
};
